import { component_tool, framework_tool, utils_tool } from '@/tool';
let { Storage } = utils_tool;
import React from 'react';
import * as local_urls from '../../../constants/constants_url';

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;

let { WizModal,WizButton,WizDataTable} = component_tool;
//配置项
let componentName = 'workflowAudit';

const columns = (e) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      name: "procDefId",
      formItem: {
        type: "hidden"
      }
    },
    {
      name: "intro",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "审核流程名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "标识Key",
      name: "key",
      dataIndex: "key",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "流程类型",
      name: "auditType",
      dataIndex: "auditType",
      dict: [
        { code: 'ApplyCommon', codeName: "公共报名" },
        { code: 'ApplyClass', codeName: "班级报名" },
        { code: '2', codeName: "考试报名" },
        { code: '3', codeName: "直播报名" },
        { code: 'ApplyActivities', codeName: "活动报名" },
        { code: '5', codeName: "投票报名" },
        { code: '6', codeName: "其他报名" }
      ],
      tableItem: {},
      searchItem: {
        type: "select"
      },
    },
    {
      title: "版本",
      name: "version",
      dataIndex: "version",
      tableItem: {}
    },
    {
      title: "流程名称",
      name: "procDefName",
      dataIndex: "procDefName",
      tableItem: {}
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {},
      dict: [
        { code: 1, codeName: "启用" },
        { code: 0, codeName: "禁用" }
      ],
      searchItem: {
        type: "select"
      },
      formItem: {
        type: "select"
      }
    },
  ];
}

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:columns(e),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort:['add','delete'],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary"},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/workflow/workflowAuditDetail'
                }
              }
            },
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort:['update'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: { children: "修改"},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/workflow/workflowAuditDetail'
              }
            }
          },
        ],
        commonOperate: {
          delete:true,
          update:true
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
  delete:{
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams:{cascade:true}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig }
